import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {sortBy} from 'lodash';
import AccessibleTypeahead from 'shared/components/accessible-typeahead';
import Label from 'shared/components/label';
import req from 'shared/req';
import CollegePortalUsers from 'src/views/admin/CollegePortalUsers';

interface University {
  id: string;
  name: string;
  nickname: string;
  slug: string;
}

const UniversityCollegePortalUsers = () => {
  const {slug} = useParams<{slug?: string}>();
  const history = useHistory();
  const [universities, setUniversities] = useState<University[]>([]);
  const [selectedUniversity, setSelectedUniversity] = useState<University | null>(null);
  const [typeaheadValue, setTypeaheadValue] = useState<University | string | null>(null);

  const updateTypeaheadValue = () => {
    setTypeaheadValue(selectedUniversity);
  };

  useEffect(() => {
    req({url: '/v1/lists/partners'}).then((data: unknown) => {
      const sorted = sortBy(data as University[], ['name']);
      setUniversities(sorted);
    });
  }, []);

  useEffect(() => {
    if (universities.length === 0) return;

    if (slug) {
      const match = universities.find((u) => u.slug === slug);
      setSelectedUniversity(match || null);
      setTypeaheadValue(match || null);
    } else {
      history.replace(`/admin/tools/college-portal-users/${universities[0].slug}`);
    }
  }, [slug, universities]);

  return (
    <div>
      <h1 className="shared-font headline">College Portal Users</h1>
      <Label>
        University
        <AccessibleTypeahead
          id="university-college-portal-typeahead"
          options={universities}
          labelKey="name"
          filterBy={['name', 'nickname']}
          value={typeaheadValue}
          onInputChange={(text: string) => setTypeaheadValue(text)}
          onBlur={updateTypeaheadValue}
          onSelect={(university: University) => {
            setSelectedUniversity(university);
            setTypeaheadValue(university);
            history.push(`/admin/tools/college-portal-users/${university.slug}`);
          }}
          placeholder="Search for a university..."
          minLength={0}
        />
      </Label>
      {selectedUniversity && (
        <CollegePortalUsers
          queryOptions={{universityId: selectedUniversity.id, impostor: 'false'}}
        />
      )}
    </div>
  );
};

export default UniversityCollegePortalUsers;
